mutation SendTrainingNudges($employeeIds: [ID!]!) {
  sendTrainingNudges(input: { employeeIds: $employeeIds }) {
    results {
      employeeId
      name
      outcome
    }
  }
}
